/**
 * O aviso "Gravando" da sala, para TODOS na chamada (atendente e convidado): gravar é dado pessoal, então quem está na sala
 * precisa saber, sem depender de olhar um ícone pequeno. É uma pílula com texto (diferente do ponto da transcrição, que só
 * diz que o texto está sendo escrito) e fica no canto da sala junto do cronômetro.
 *
 * - gravando: pílula vermelha "Gravando" (inclusive enquanto a mídia ainda confirma: na dúvida, avisa);
 * - pedido esperando o aceite: pílula âmbar, com o texto de cada lado ("Esperando o aceite para gravar" / "O atendente pediu
 *   para gravar").
 *
 * CSS dentro da pílula, sem tooltip do Radix: a sala também roda na janela flutuante (outro documento).
 */
import { Circle } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useCallRecording } from './recordingContext';
import { ROOM_RECORDING_STATE } from './recordingProtocol';
import { BADGE_RECORDING, BADGE_RECORDING_LABEL, BADGE_REQUESTED_AGENT, BADGE_REQUESTED_GUEST } from './recordingCopy';

/** @param {{ compact?: boolean }} props `compact`: janela pequena (flutuante ou do canto), com texto menor */
export function RoomRecordingBadge({ compact = false }) {
    const recording = useCallRecording();
    if (!recording || recording.state === ROOM_RECORDING_STATE.NONE) return null;

    const isRecording = recording.state === ROOM_RECORDING_STATE.RECORDING;
    const text = isRecording ? BADGE_RECORDING : (recording.agent ? BADGE_REQUESTED_AGENT : BADGE_REQUESTED_GUEST);
    return (
        <span
            role="status"
            aria-label={isRecording ? BADGE_RECORDING_LABEL : text}
            data-room-recording={recording.state}
            className={cn(
                'pointer-events-auto inline-flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-1 font-medium shadow-lg ring-1',
                compact ? 'text-xs' : 'text-sm',
                isRecording ? 'bg-red-600 text-white ring-red-300/50' : 'bg-amber-400 text-black ring-amber-200/60',
            )}
        >
            <Circle
                className={cn('h-2.5 w-2.5 shrink-0 fill-current', isRecording && 'animate-pulse motion-reduce:animate-none')}
                aria-hidden="true"
            />
            <span aria-hidden="true">{text}</span>
        </span>
    );
}
